import React, {useState, Fragment} from 'react';
import { nuevoOActualizarRegistroPersonalizado, obtenerRegistrosPorURL } from 'store/actions/customAction';
import TooltipPersonalizado from 'components/tooltip/TooltipPersonalizado';
import DatosDeEmpresa from 'components/nuevoTarifario/DatosDeEmpresa';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import {useDispatch} from 'react-redux';
import NuevaPantallDigital from './NuevaPantallaDigital';
import { alertaPersonalizadaSwal } from 'servicios/AlertasPersonalizados';
import DetalleDeLaPantallaDigital from './DetalleDeLaPantallaDigital';
import ModalDeConfirmacion from 'components/Modales/ModalDeConfirmacion';

const PantallaDigital = () => {
    const dispatch = useDispatch();
    const [tarifarioDePantallasDigitales] = useState('tarifarioDePantallasDigitales');
    const [datosDeRespuesta, setDatosDeRespuesta] = useState({ tipoDeAlerta: 'error', mensajeDeAlerta: '', mostrarRespuesta: false, });
    const[cargandoSolicitud, setCargandoSolicitud] = useState(false);
    const [abrirNuevaPantallaDigital, setAbrirNuevaPantallaDigital] = useState(false);
    const [steps] = useState( [{id: 0,  label: 'Datos del Canal'}, {id: 1, label: "Tarifario y Disponibilidad"}, {id: 2, label: "Cobertura"}, {id: 3, label: "Datos Demográficos"}]);
    const [datosDeEmpresa, setDatosDeEmpresa] = useState({});
    const [recargarLaTabla, setRecargarLaTabla] = useState(false),
    [datosGeneralesDelTarifario, setDatosGeneralesDelTarifario] = useState({}),
    [abrirDetalleTarifario, setAbrirDetalleTarifario] = useState(false),
    [alertaDeConfirmacion, setAlertaDeConfirmacion] = useState(false);

    const [header] = useState([
        { title: 'Departamento', field: 'departamento.nombre'},
        { title: 'Municipio', field: 'municipio.nombre'},
        { title: 'Coordenadas de Ubicación', field: 'coordenadas'},
        { title: 'Acciones', field: 'accion',
        render: rowData=><div style={{minWidth: '100px'}}>
            {
                (<div>
                    <TooltipPersonalizado title="Visualizar detalle de la pantalla digital" handleFunction={() => mostrarDetalleDelMedio(rowData)} icon="visibility" fontSize={30} />
                    {/* <TooltipPersonalizado title="Editar pantalla digital" handleFunction={() => showModalCoalitionResume(rowData?.idOp)} icon="edit" fontSize={30} /> */}
                    <TooltipPersonalizado title="Eliminar pantalla digital" handleFunction={() => mostrarAlertaDeConfirmacion(rowData)} icon="delete" fontSize={30} color="red" />
                </div>)
            }
            </div>
        },
    ]);

    const mostrarAlertaDeConfirmacion = async (elemento) => {
        setDatosGeneralesDelTarifario(elemento)
        setAlertaDeConfirmacion(true)
    }

    const mostrarDetalleDelMedio = async (elemento) => {
        setCargandoSolicitud(true);

        let respuesta = await dispatch(obtenerRegistrosPorURL({ controller: tarifarioDePantallasDigitales, saveInStore: false, nombreDelMetodo: "listar/registros", parametro: elemento.medioDeComunicacion?.id}));

        setCargandoSolicitud(false);

        if(respuesta?.error) return alertaPersonalizadaSwal(`${respuesta.error?.message || "No se pudo obtener la información de la pantalla digital"}`);

        if(respuesta?.data?.length === 0) return alertaPersonalizadaSwal("No existen datos para mostrar");

        setDatosGeneralesDelTarifario(respuesta.data)
        setAbrirDetalleTarifario(true)
    }

    const handClose = (_, reason) => {
        if (reason === 'clickaway') {return}
        changeDataResponse('error', '', false)
    };

    const changeDataResponse = (tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta = false) => setDatosDeRespuesta({tipoDeAlerta,mensajeDeAlerta,mostrarRespuesta,})

    const addRegister= () => {
        if(!datosDeEmpresa?.ejecutivoDeMedios?.cui) return alertaPersonalizadaSwal("Debe completar los datos Contacto de medios para agregar otra pantalla digital", "", "warning")
        setAbrirNuevaPantallaDigital(true);
    }

    const cerrarPantallaDigital= (recargar = false) => {
        setAbrirNuevaPantallaDigital(false);
        setRecargarLaTabla(recargar)
    };

    const cerrarDetalleDelTarifario = () => setAbrirDetalleTarifario(false)

    const accionDeAlertaDeConfirmacion = async () => {
        setAlertaDeConfirmacion(false);
        setCargandoSolicitud(true);
        changeDataResponse('error', "")

        const data = { controller: tarifarioDePantallasDigitales, action: 'deshabilitar', data: {}, nombreDelMetodo: `deshabilitar/${datosGeneralesDelTarifario?.medioDeComunicacion?.id}` };
        const respuesta = await dispatch(nuevoOActualizarRegistroPersonalizado(data));
        setCargandoSolicitud(false);
        if(respuesta?.error) return alertaPersonalizadaSwal(respuesta.error?.message || "", "", '');
        alertaPersonalizadaSwal(respuesta?.data || "Registro eliminado correctamente", "", 'success');
        setRecargarLaTabla(true)
    }

    const cerrarAlertaDeConfirmacion = () => setAlertaDeConfirmacion(false);

    const { tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta} = datosDeRespuesta;

    return (
        <Fragment>
            {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }
            <AlertaDeRespuesta type={tipoDeAlerta} content={mensajeDeAlerta} open={mostrarRespuesta} handClose={handClose}/>

            <DatosDeEmpresa
                header={header}
                tituloGeneral={"FORMULARIO DE PANTALLA DIGITAL"}
                icon={"pantalla_digital"}
                tituloDeTabla={"LISTADO DE PANTALLAS DIGITALES REGISTRADAS"}
                addRegister={addRegister}
                nombreToolTip={"AGREGAR OTRA PANTALLA DIGITAL"}
                iconTabla={"pantalla_digital"}
                setDatosDeEmpresa={setDatosDeEmpresa}
                controladorTarifario={"tarifarioDePantallasDigitales"}
                recargarLaTabla={recargarLaTabla}
                datosDeEmpresa={datosDeEmpresa}
                setRecargarLaTabla={setRecargarLaTabla}
                tipoMedio="pantallas"
            />

            {abrirNuevaPantallaDigital && (
                <NuevaPantallDigital
                    openFullScreenDialog={abrirNuevaPantallaDigital}
                    handleClose={cerrarPantallaDigital}
                    title={"Formulario para agregar nueva pantalla digital"}
                    steps={steps}
                    datosDeEmpresa={datosDeEmpresa}
                />
            )}
            {abrirDetalleTarifario && (
                <DetalleDeLaPantallaDigital
                    openFullScreenDialog={abrirDetalleTarifario}
                    handleClose={cerrarDetalleDelTarifario}
                    title={'Detalle de la pantalla digital'}
                    datosGeneralesDelTarifario={datosGeneralesDelTarifario}
                    mostrarDetalleDelMedio={mostrarDetalleDelMedio}
                    tipoDelMedio={"pantallas"}
                />
            )}
            {alertaDeConfirmacion && (
                <ModalDeConfirmacion
                    title={`¿Está seguro de eliminar la pantalla digital ${datosGeneralesDelTarifario?.medioDeComunicacion?.nombre || ""}?`} message={"No podrá revertir esta acción"}
                    open={alertaDeConfirmacion} closeModal={cerrarAlertaDeConfirmacion} titleButton={"Sí, estoy seguro"}
                    actionAdd={accionDeAlertaDeConfirmacion}
                />
            )}
        </Fragment>
    );
}

export default PantallaDigital;